
import Otp from '@/components/common/OTP/Otp.vue'
import OtpGroup from '@/components/common/OTP/OtpGroup.vue'
import OtpGroupInput from '@/components/common/OTP/OtpGroupInput.vue'

export default {
    name: 'OneTimePassword',
    components: {
        Otp,
        OtpGroup,
        OtpGroupInput
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        count: {
            type: Number,
            default: 4
        }
    },
    data () {
        return {
            pin: ''
        }
    },
    watch: {
        pin (pin) {
            this.$emit('input', pin)
        },
        value (value) {
            this.pin = value
        }
    },
    mounted () {
        // TODO
        // navigator.credentials.get({
        //     otp: { transport: ['sms'] }
        // }).then((otp) => {
        //     this.$emit('input', otp.code)
        //     // Automatically submit the form when an OTP is obtained.
        // }).catch((err) => {
        //     console.log(err)
        // })
    }
}
